import { render } from "./TextRadioButton.vue?vue&type=template&id=1f10cbfc&scoped=true&ts=true"
import script from "./TextRadioButton.vue?vue&type=script&lang=ts"
export * from "./TextRadioButton.vue?vue&type=script&lang=ts"

import "./TextRadioButton.vue?vue&type=style&index=0&id=1f10cbfc&lang=scss&scoped=true"
import "./TextRadioButton.vue?vue&type=style&index=1&id=1f10cbfc&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f10cbfc"]])

export default __exports__